import React from "react";
import {
  List,
  Show,
  TabbedShowLayout,
  Tab,
  Edit,
  Datagrid,
  TextField,
  BooleanField,
  NumberField,
  ChipField,
  ArrayField,
  ReferenceManyField,
  DateField,
  CardActions,
  Create,
  SimpleForm,
  TextInput,
  EditButton,
  Pagination,
  TabbedForm,
  FormTab,
} from "react-admin";
import Button from "@material-ui/core/Button";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { push } from "react-router-redux";
import Drawer from "@material-ui/core/Drawer";

import { DoctorReferenceField } from "../../misc/customFields";
import { ChipFieldStationUID } from "./common";
import CSVDetail from "./CSVDetail";
import MainFilter from "./filters";

const ActivateStationButton = ({ record }) => (
  <Button
    component={Link}
    to={{
      pathname: "/station_activations/create",
      state: {
        record: { station: record.id, devices: record.devices },
        fromStations: true,
      },
    }}
    disabled={Number(record.remaining_activations) === 0}
  >
    Activate Station
  </Button>
);

const ImportMasterButton = ({ record, openImportModal }) => (
  <Button
    color="primary"
    component="span"
    onClick={() => openImportModal(true)}
  >
    IMPORT MASTER
  </Button>
);

const StationActions = ({
  resource,
  dispatch,
  basePath,
  filters,
  showFilter,
  displayedFilters,
  filterValues,
  openImportModal,
}) => (
  <CardActions>
    {filters &&
      React.cloneElement(filters, {
        resource,
        showFilter,
        displayedFilters,
        filterValues,
        context: "button",
      })}
    <ImportMasterButton
      resource={resource}
      dispatch={dispatch}
      basePath={basePath}
      openImportModal={openImportModal}
    />
  </CardActions>
);

class StationList_ extends React.Component {
  constructor(props) {
    super();
    this.state = { isOpen: false };
    this.setOpen = this.setOpen.bind(this);
  }
  setOpen(value) {
    this.setState({ isOpen: value });
  }

  render() {
    const props = this.props;
    return (
      <React.Fragment>
        <List
          {...props}
          actions={<StationActions openImportModal={this.setOpen} />}
          filters={<MainFilter />}
        >
          <Datagrid>
            <EditButton />
            <ChipFieldStationUID source="uid" />
            <DateField source="created" showTime />
            <TextField source="remaining_activations" />
            <TextField source="note" />
            <ActivateStationButton />
          </Datagrid>
        </List>
        <Drawer
          variant="persistent"
          open={this.state.isOpen}
          anchor="right"
          onClose={() => this.setOpen(false)}
        >
          {this.state.isOpen ? (
            <CSVDetail {...props} onCancel={() => this.setOpen(false)} />
          ) : null}
        </Drawer>
      </React.Fragment>
    );
  }
}

export const StationList = connect(undefined, { push })(StationList_);

const StationDefaultTitle = ({ record }) => {
  return <span style={{ width: "100%" }}>Create Default Station</span>;
};

export const StationDefaultCreate = (props) => (
  <Create {...props} title={<StationDefaultTitle />}>
    <SimpleForm>
      <TextInput source="uid" />
    </SimpleForm>
  </Create>
);

export const StationEdit = (props) => (
  <Edit {...props}>
    <SimpleForm>
      <ChipFieldStationUID source="uid" />
      <TextInput source="note" />
    </SimpleForm>
  </Edit>
);

export const StationShow = (props) => (
  <Show {...props}>
    <TabbedShowLayout>
      <Tab label="Station">
        <TextField source="uid" />
        <NumberField source="remaining_activations" />
      </Tab>
      <Tab label="Activations">
        <ReferenceManyField
          label="Activations"
          reference="station_activations"
          target="station"
          pagination={<Pagination />}
        >
          <Datagrid>
            <TextField source="id" />
            <DateField source="activation_date" showTime />
            <ChipFieldStationUID label="Station" source="station_uid" />
            <ChipField label="Device" source="device_serial_number" />
            <DoctorReferenceField />
            <BooleanField source="status" />
          </Datagrid>
        </ReferenceManyField>
      </Tab>
      <Tab label="Devices" path="devices">
        <ArrayField source="devices">
          <Datagrid>
            <ChipField source="name" label="Serial number" />
            <BooleanField source="used" label="Used" />
            <EditButton basePath="/station_devices" />
          </Datagrid>
        </ArrayField>
      </Tab>
    </TabbedShowLayout>
  </Show>
);

export const StationEdit2 = (props) => (
  <Edit {...props}>
    <TabbedForm>
      <FormTab label="Station">
        <TextField source="uid" />
        <NumberField source="remaining_activations" />
        <TextInput source="note" />
      </FormTab>
      <FormTab label="Activations">
        <ReferenceManyField
          label="Activations"
          reference="station_activations"
          target="station"
          pagination={<Pagination />}
        >
          <Datagrid>
            <TextField source="id" />
            <DateField source="activation_date" showTime />
            <ChipFieldStationUID label="Station" source="station_uid" />
            <ChipField label="Device" source="device_serial_number" />
            <DoctorReferenceField />
            <BooleanField source="status" />
          </Datagrid>
        </ReferenceManyField>
      </FormTab>
      <FormTab label="Devices" path="devices">
        <ArrayField source="devices">
          <Datagrid>
            <ChipField source="name" label="Serial number" />
            <BooleanField source="used" label="Used" />
            <EditButton basePath="/station_devices" />
          </Datagrid>
        </ArrayField>
      </FormTab>
    </TabbedForm>
  </Edit>
);
